module.exports = "<div [hidden]=\"!isLoading\">\n  <mat-progress-spinner mode=\"indeterminate\" [strokeWidth]=\"2\" [diameter]=\"32 * size\"></mat-progress-spinner>\n  <span class=\"message\">{{message}}</span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loader/loader.component.html
// module id = 1075
// module chunks = 0